import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import SmsOutlinedIcon from '@material-ui/icons/SmsOutlined';
import PopupMessage from './PopupMessage';
import { setShowPopup } from '../../../../../redux/slices/inspectionsSlice';

const InspectionCompleteConfirmation = () => {
  const dispatch = useDispatch();

  return (
    <PopupMessage caption="Send completion message?">
      <IconBadge aria-hidden="true">
        <SmsOutlinedIcon />
      </IconBadge>
      <p>
        This will text the inspection contact letting them know the
        inspection is complete. Do you want to continue?
      </p>
      <Actions>
        <SecondaryButton
          type="button"
          onClick={() => dispatch(setShowPopup('none'))}
        >
          Cancel
        </SecondaryButton>
        <PrimaryButton
          type="button"
          onClick={() => dispatch(setShowPopup('saving'))}
        >
          Send message
        </PrimaryButton>
      </Actions>
    </PopupMessage>
  );
};

export default InspectionCompleteConfirmation;

const IconBadge = styled.div`
  align-self: center;
  width: 56px;
  height: 56px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-50);
  color: var(--primary-600);

  svg {
    width: 28px;
    height: 28px;
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 4px;

  @media only screen and (max-width: 540px) {
    flex-direction: column-reverse;
  }
`;

const BaseButton = styled.button`
  flex: 1;
  min-width: 0;
  height: 40px;
  padding: 0 18px;
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-transform: none;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;

const PrimaryButton = styled(BaseButton)`
  border: none;
  background: var(--primary-600);
  color: var(--neutral-0);

  &:hover {
    background: var(--primary-700);
  }
`;

const SecondaryButton = styled(BaseButton)`
  border: 1px solid var(--border);
  background: var(--neutral-0);
  color: var(--neutral-700);

  &:hover {
    background: var(--neutral-50);
    border-color: var(--neutral-400);
  }
`;
